import styled from "styled-components";
//interfaces
import { ISidebarButton } from "./interface";

export const SidebarButton = styled.button<ISidebarButton>`
  position: absolute;
  left: 0;
  top: 80px;

  width: 32px;
  height: 40px;

  border-radius: 0px 4px 4px 0px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3);

  z-index: 999;

  img {
    user-select: none;
  }
`;